type RiskCategory =
  | 'cautious'
  | 'moderately cautious'
  | 'moderate'
  | 'moderately adventurous'
  | 'adventurous';

const ranges = {
  cautious: [0, 33],
  'moderately cautious': [34, 47],
  moderate: [48, 59],
  'moderately adventurous': [60, 72],
  adventurous: [73, 100]
};

const data: Record<RiskCategory, { name: string; value: number }[]> = {
  cautious: [
    { name: 'Cash', value: 10.5 },
    { name: 'UK Fixed Income', value: 22.5 },
    { name: 'Global Fixed Income (Ex UK)', value: 57 },
    { name: 'UK Equity', value: 3 },
    { name: 'Developed European Equity (Ex UK)', value: 0 },
    { name: 'Developed Global Equity (Ex Europe)', value: 7 },
    { name: 'Emerging Markets Equity', value: 0 }
  ],
  'moderately cautious': [
    { name: 'Cash', value: 9.5 },
    { name: 'UK Fixed Income', value: 18.5 },
    { name: 'Global Fixed Income (Ex UK)', value: 42 },
    { name: 'UK Equity', value: 7.5 },
    { name: 'Developed European Equity (Ex UK)', value: 4.5 },
    { name: 'Developed Global Equity (Ex Europe)', value: 16 },
    { name: 'Emerging Markets Equity', value: 2 }
  ],
  moderate: [
    { name: 'Cash', value: 7.5 },
    { name: 'UK Fixed Income', value: 13 },
    { name: 'Global Fixed Income (Ex UK)', value: 29.5 },
    { name: 'UK Equity', value: 13 },
    { name: 'Developed European Equity (Ex UK)', value: 7.5 },
    { name: 'Developed Global Equity (Ex Europe)', value: 26.5 },
    { name: 'Emerging Markets Equity', value: 3 }
  ],
  'moderately adventurous': [
    { name: 'Cash', value: 7 },
    { name: 'UK Fixed Income', value: 8 },
    { name: 'Global Fixed Income (Ex UK)', value: 15 },
    { name: 'UK Equity', value: 19 },
    { name: 'Developed European Equity (Ex UK)', value: 10 },
    { name: 'Developed Global Equity (Ex Europe)', value: 36 },
    { name: 'Emerging Markets Equity', value: 5 }
  ],
  adventurous: [
    { name: 'Cash', value: 4 },
    { name: 'UK Fixed Income', value: 1.5 },
    { name: 'Global Fixed Income (Ex UK)', value: 4.5 },
    { name: 'UK Equity', value: 20 },
    { name: 'Developed European Equity (Ex UK)', value: 12.5 },
    { name: 'Developed Global Equity (Ex Europe)', value: 50 },
    { name: 'Emerging Markets Equity', value: 7.5 }
  ]
};

const getRiskCategory = (riskTolerance: number): RiskCategory | null => {
  for (const [key, [min, max]] of Object.entries(ranges)) {
    if (riskTolerance >= min && riskTolerance <= max) {
      return key as RiskCategory;
    }
  }
  return null;
};

export const getTargetAllocationData = (score: number) => {
  const category = getRiskCategory(score);
  return category ? data[category] : [];
};
